import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const RuleWrapper = styled(Grid)(() => ({
  padding: "12px 0",
}));

export const Divider = styled("div")(() => ({
  background: colors.gray200,
  height: "1px",
  margin: "24px 0 16px",
  width: "100%",
}));

export const Footer = styled(Grid)(() => ({
  padding: "0px !important",
  width: "100%",
}));

export const RuleField = styled(Grid)(() => ({
  minWidth: "248px !important",
}));

export const RemoveRuleField = styled(Grid)(() => ({
  alignSelf: "flex-start",
  display: "flex",

  marginTop: "12px !important",
  padding: "0 !important",
}));

export const useStyles = makeStyles(() => ({
  button: {
    padding: "9px 0px !important",
  },
  icon: {
    cursor: "pointer",
    marginTop: "28px",
  },
}));
